// ==========================================================
// app/politique-cookies.tsx — Politique de Cookies v1.1
// ==========================================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalDocumentScreen, { LegalSection } from '../components/LegalDocumentScreen';

const VIOLET       = '#6411A9';
const VIOLET_LIGHT = '#9B30E8';
const GOLD         = '#F5A623';
const SUCCESS      = '#00A86B';
const DANGER       = '#E8003D';
const BLUE         = '#3B82F6';

function useSections(t: (key: string, opts?: any) => any): LegalSection[] {
  return [
    {
      id: 'definition', num: '01', icon: 'help-circle-outline', color: VIOLET_LIGHT,
      title: t('politiqueCookies.sections.definition.title'),
      content: [
        { type: 'paragraph', text: t('politiqueCookies.sections.definition.p1') },
        { type: 'highlight', text: t('politiqueCookies.sections.definition.highlight1'), icon: 'checkmark-circle' },
      ],
    },
    {
      id: 'politique', num: '02', icon: 'shield-checkmark-outline', color: SUCCESS,
      title: t('politiqueCookies.sections.politique.title'),
      content: [
        { type: 'paragraph', text: t('politiqueCookies.sections.politique.p1') },
        { type: 'highlight', text: t('politiqueCookies.sections.politique.highlight1'), icon: 'ban' },
        { type: 'paragraph', text: t('politiqueCookies.sections.politique.p2') },
      ],
    },
    {
      id: 'utilises', num: '03', icon: 'server-outline', color: VIOLET,
      title: t('politiqueCookies.sections.utilises.title'),
      content: [
        { type: 'paragraph', text: t('politiqueCookies.sections.utilises.p1') },
        { type: 'subtitle', text: t('politiqueCookies.sections.utilises.sub1') },
        { type: 'paragraph', text: t('politiqueCookies.sections.utilises.p2') },
        { type: 'highlight', text: t('politiqueCookies.sections.utilises.highlight1'), icon: 'lock-open' },
        { type: 'subtitle', text: t('politiqueCookies.sections.utilises.sub2') },
        { type: 'paragraph', text: t('politiqueCookies.sections.utilises.p3') },
        { type: 'subtitle', text: t('politiqueCookies.sections.utilises.sub3') },
        { type: 'paragraph', text: t('politiqueCookies.sections.utilises.p4') },
        { type: 'subtitle', text: t('politiqueCookies.sections.utilises.sub4') },
        { type: 'paragraph', text: t('politiqueCookies.sections.utilises.p5') },
      ],
    },
    {
      id: 'non-utilises', num: '04', icon: 'ban-outline', color: DANGER,
      title: t('politiqueCookies.sections.nonUtilises.title'),
      content: [
        { type: 'paragraph', text: t('politiqueCookies.sections.nonUtilises.p1') },
        { type: 'bullet', items: t('politiqueCookies.sections.nonUtilises.bullets1', { returnObjects: true }) },
      ],
    },
    {
      id: 'mobile', num: '05', icon: 'phone-portrait-outline', color: BLUE,
      title: t('politiqueCookies.sections.mobile.title'),
      content: [
        { type: 'paragraph', text: t('politiqueCookies.sections.mobile.p1') },
        { type: 'highlight', text: t('politiqueCookies.sections.mobile.highlight1'), icon: 'lock-open' },
        { type: 'paragraph', text: t('politiqueCookies.sections.mobile.p2') },
      ],
    },
    {
      id: 'duree', num: '06', icon: 'time-outline', color: GOLD,
      title: t('politiqueCookies.sections.duree.title'),
      content: [
        { type: 'bullet', items: t('politiqueCookies.sections.duree.bullets1', { returnObjects: true }) },
      ],
    },
    {
      id: 'gestion', num: '07', icon: 'settings-outline', color: VIOLET_LIGHT,
      title: t('politiqueCookies.sections.gestion.title'),
      content: [
        { type: 'subtitle', text: t('politiqueCookies.sections.gestion.sub1') },
        { type: 'bullet', items: t('politiqueCookies.sections.gestion.bullets1', { returnObjects: true }) },
        { type: 'highlight', text: t('politiqueCookies.sections.gestion.highlight1'), icon: 'warning' },
        { type: 'subtitle', text: t('politiqueCookies.sections.gestion.sub2') },
        { type: 'paragraph', text: t('politiqueCookies.sections.gestion.p1') },
        { type: 'subtitle', text: t('politiqueCookies.sections.gestion.sub3') },
        { type: 'paragraph', text: t('politiqueCookies.sections.gestion.p2') },
      ],
    },
    {
      id: 'modifications', num: '08', icon: 'refresh-outline', color: BLUE,
      title: t('politiqueCookies.sections.modifications.title'),
      content: [
        { type: 'paragraph', text: t('politiqueCookies.sections.modifications.p1') },
        { type: 'highlight', text: t('politiqueCookies.sections.modifications.highlight1'), icon: 'checkmark-circle' },
      ],
    },
    {
      id: 'contact', num: '09', icon: 'mail-outline', color: SUCCESS,
      title: t('politiqueCookies.sections.contact.title'),
      content: [
        { type: 'highlight', text: 'harmonia@harmoniaworld.world', icon: 'mail' },
        { type: 'paragraph', text: t('politiqueCookies.sections.contact.p1') },
      ],
    },
  ];
}

export default function PolitiqueCookiesScreen() {
  const { t } = useTranslation();
  const SECTIONS = useSections(t);

  return (
    <LegalDocumentScreen
      title={t('politiqueCookies.title')}
      version="v1.1"
      sections={SECTIONS}
      currentRoute="/politique-cookies"
      stats={[
        { value: '9', label: t('politiqueCookies.stats.sections') },
        { isIcon: true, iconName: 'ban',         iconColor: '#FFC947', label: t('politiqueCookies.stats.zeroTracking') },
        { isIcon: true, iconName: 'lock-closed', iconColor: '#FFC947', label: t('politiqueCookies.stats.essentialOnly') },
      ]}
    />
  );
}
